import * as React from "react";
import { createSvgIcon } from "@material-ui/core/utils";
export var iconPath = (React.createElement("path", { d: "M3.426 7.05v9.9L12 21.9l4.287-2.475 4.287 2.475v-4.95l-4.287-2.475L12 16.95l-4.287-2.475v-4.95L12 7.05l4.287 2.475v4.95L20.574 12V7.05L12 2.1 3.426 7.05z" }));
export default createSvgIcon(iconPath, "Quixel");
//# sourceMappingURL=QuixelIcon.js.map